import React, { PropsWithChildren } from 'react';

type InvisiblyDefinedTerm = {
  className?: string;
  definition: string;
};

export function InvisiblyDefinedTerm({ className, definition, children }: PropsWithChildren<InvisiblyDefinedTerm>) {
  return (
    <p className={className}>
      <dfn className="invisible">{definition}: </dfn>
      {children}
    </p>
  );
}
